/**
 * An Error indicating that the request to the GraphQL service failed.
 */
export class GraphQLRequestError extends Error {}

/**
 * An Error indicating that the value of an argument or variables is not correct.
 * Such as, receiving an empty string when expecting a populated one.
 */
export class ValueError extends Error {}

/**
 * An Error indicating that an item being added to the cache already exists.
 */
export class ItemExistsInCacheError extends Error {}

/**
 * An Error indicating that id does not exist in the cache.
 */
export class ItemByIdDoesNotExistInCacheError extends Error {}

/**
 * An Error indicating that a class method (instance or otherwise) is not implemented.
 */
export class NotImplementedError extends Error {}
